export const DEFAULT_PROFESSION = "Licenciado/a";
export const LOGISTICS_PROFESSION = "Logistica";

export const PROFESSION_OPTIONS = Object.freeze([
  { value: "Doctor/a", label: "Doctor/a" },
  { value: DEFAULT_PROFESSION, label: DEFAULT_PROFESSION },
  { value: "Tecnico/a", label: "Técnico/a" },
  { value: "Cuidador/a", label: "Cuidador/a" },
  { value: "fisioterapeuta", label: "Fisioterapeuta" },
  { value: "Auxiliar", label: "Auxiliar" },
  { value: LOGISTICS_PROFESSION, label: "Logística" },
]);

const LEGACY_PROFESSIONS = Object.freeze({
  Doctor: "Doctor/a",
  "Docto/a": "Doctor/a",
  Licenciado: DEFAULT_PROFESSION,
  Tecnico: "Tecnico/a",
  Cuidador: "Cuidador/a",
  Fisioterapsita: "fisioterapeuta",
  Fisioterapeuta: "fisioterapeuta",
  "Logística": LOGISTICS_PROFESSION,
});

export const normalizeProfession = (profession) =>
  LEGACY_PROFESSIONS[profession] || profession || DEFAULT_PROFESSION;

export const getAccountTypeForProfession = (profession) =>
  normalizeProfession(profession) === LOGISTICS_PROFESSION ? "3" : "2";

export const getProfessionForAccount = (account = {}) => {
  const accountType = account.IdTipoUsuario ?? account.tipousuario;

  if (String(accountType) === "3") {
    return LOGISTICS_PROFESSION;
  }

  return normalizeProfession(account.subtipo);
};

export const getProfessionLabel = (profession) => {
  const normalizedProfession = normalizeProfession(profession);
  return (
    PROFESSION_OPTIONS.find(({ value }) => value === normalizedProfession)?.label ||
    normalizedProfession
  );
};
